module.exports = __webpack_public_path__ + "public/img/duty_2.66cdb2fd.png";